<ul
    class="list-group w-100 text-break"
    infiniteScroll
    [fromRoot]="true"
    [infiniteScrollContainer]="infiniteScrollContainerClass"
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    (scrolled)="loadMore()">
    @for (notification of notifications; track notification) {
        <li class="list-group-item list-group-item-action">
            <a
                class="notification-link"
                (click)="openNotification($event, notification)"
                [href]="getNotificationLink(notification)">
                @if (isNotificationWithAuthor(notification)) {
                    <sb-user-avatar
                        class="user-avatar-sm align-self-start mt-1 me-2"
                        (click)="preventNavigation($event); openUserInfo(notification.message.author)"
                        [user]="notification.message?.author"
                        [size]="'small'">
                    </sb-user-avatar>
                } @else if (
                    notification.type === notificationTypeEnum.ticketReminder ||
                    notification.type === notificationTypeEnum.replyReminder
                ) {
                    <sb-inline-svg
                        class="icon"
                        style="padding: 0; margin-right: 15px"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Timer outlined icon.svg'">
                    </sb-inline-svg>
                } @else if (notification.type === notificationTypeEnum.ticketSurveyResponseAdded) {
                    <sb-inline-svg
                        class="icon"
                        style="padding: 0; margin-right: 15px"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Survey icon.svg'">
                    </sb-inline-svg>
                } @else if (notification.type === notificationTypeEnum.emailDeliveryStatusUpdate) {
                    <sb-inline-svg
                        class="icon"
                        style="padding: 0; margin-right: 15px"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Warning icon v1.svg'">
                    </sb-inline-svg>
                }

                <div class="notification-content">
                    <div class="text-break">
                        @if (isNotificationWithAuthor(notification)) {
                            <a (click)="preventNavigation($event); openUserInfo(notification.message?.author)">
                                {{ notification.message?.author.name || notification.message?.author.email }}
                            </a>
                        }
                        <span
                            [ngClass]="{
                                'text-light':
                                    notification.type !== notificationTypeEnum.ticketReminder &&
                                    notification.type !== notificationTypeEnum.replyReminder &&
                                    notification.type !== notificationTypeEnum.ticketSurveyResponseAdded,
                                'notification-title':
                                    notification.type === notificationTypeEnum.ticketReminder ||
                                    notification.type === notificationTypeEnum.replyReminder ||
                                    notification.type === notificationTypeEnum.ticketSurveyResponseAdded,
                            }"
                            >{{ notification | notificationExplanatoryText }}</span
                        >
                    </div>
                    @if (isNotificationWithAuthor(notification)) {
                        <app-highlight-mention
                            class="notification-list-item-text"
                            [message]="notification.message.text"
                            [mentionedUsers]="notification.message.mentionedUsers"
                            [mentionedGroups]="notification.message.mentionedGroups">
                        </app-highlight-mention>
                    }

                    <small class="md-secondary text-light d-block">
                        {{ notification.creationTime | ticketTime }}
                        @if (commonDataService.user.communityCount > 1) {
                            - {{ notification.communityName }}
                        }
                    </small>
                </div>
                <span class="flex-fill"></span>
                <div
                    class="notification-badge-area"
                    [adaptivePosition]="false"
                    tooltip="{{ notification.isRead ? ('Mark as unread' | translate) : ('Mark as read' | translate) }}"
                    container="body"
                    (click)="preventNavigation($event); read(notification, !notification.isRead)">
                    <div
                        class="notification-badge notification-badge-item"
                        [ngClass]="{ 'notification-badge-item-new': !notification.isRead }"></div>
                </div>
            </a>
        </li>
    }
</ul>

@if (isLoading) {
    <sb-loader></sb-loader>
} @else {
    @if (!isShowUnread && areAllNotificationsLoaded && notifications.length) {
        <div class="limit-info text-light" translate>That's all your notifications from the last 30 days.</div>
    }
    @if (isShowUnread && !notifications.length) {
        <div class="limit-info text-light no-border" translate>
            You've read all your notifications from the last 30 days.
        </div>
    }
    @if (isShowUnread && notifications.length) {
        <div class="limit-info text-light" translate>That's all your unread notifications from the last 30 days.</div>
    }
    @if (!notifications.length && !isShowUnread) {
        <div class="text-light text-center pt-4 pb-4">
            {{ "You don't have notifications" | translate }}
        </div>
    }
}
